import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Col,
  Row,
  Tag,
  Divider,
  InputNumber,
  Switch,
  Space,
  message,
} from 'antd';
import { StoreContext } from '../store/index';
import { getDateFromTimestamp } from '../utils';
import PlayersList from './PlayersList';
import { fetchUsers } from '../adminPanel/api';

function ListUsersModal({
  visible,
  onClose,
  handleAddPlayerToTeam,
  usersToFilter,
  title = '',
  players,
}) {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!players) {
      fetchUsers(setLoading).then(data => {
        setUsers(
          data.filter(
            d => usersToFilter.find(u => u.id === d.id) === undefined,
          ),
        );
      });
    } else {
      setUsers(
        players.filter(
          d => usersToFilter.find(u => u.id === d.id) === undefined,
        ),
      );
    }
  }, [usersToFilter]);

  const onFinish = () => {
    onClose();
  };

  return (
    <Modal
      title={title}
      open={visible}
      onOk={onFinish}
      okButtonProps={{ loading: loading }}
      onCancel={onClose}>
      <PlayersList
        header="Players"
        dataSource={users}
        handleAddPlayerToTeam={handleAddPlayerToTeam}
      />
    </Modal>
  );
}

export default ListUsersModal;
